import React from "react";
import { Link } from "react-router-dom";
import { Truck, Scale, FileCheck, Recycle, ArrowRight, MapPin } from "lucide-react";
import { SITE } from "./config";
import Seo from "./Seo";

export default function CommentCaMarche() {
  return (
    <div>
      <Seo
        title="Comment ça marche — déposer ses déchets à Saint-Victoret"
        description="4 étapes simples pour apporter vos déchets professionnels chez FB Environnement à Saint-Victoret : arrivée sur site, pesée, déchargement et certificat de valorisation."
        path="/comment-ca-marche"
      />
      <section className="bg-gradient-to-br from-[#1F6B2E] to-[#0f3a18] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
          <span className="inline-block bg-[#9DCB2E] text-[#0f3a18] font-black uppercase tracking-[0.15em] text-xs px-3 py-1.5 rounded-full">
            Process clair
          </span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mt-5 max-w-3xl">
            Comment ça marche
          </h1>
          <p className="text-stone-100 text-lg mt-4 max-w-2xl">
            Apporter vos déchets chez nous, c&apos;est simple et rapide. Voici les 4 étapes.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 space-y-5">
        {[
          {
            n: "1",
            icon: <Truck className="w-7 h-7" strokeWidth={2.5} />,
            t: "Vous arrivez sur site",
            d: "Direction le 30 chemin de la Carrère à Saint-Victoret. Aucun rendez-vous nécessaire pendant nos horaires d'ouverture (Lun-Ven 7h-17h non-stop).",
          },
          {
            n: "2",
            icon: <Scale className="w-7 h-7" strokeWidth={2.5} />,
            t: "Pesée à l'entrée",
            d: "Notre pont-bascule pèse votre véhicule plein. Vous nous indiquez la nature des déchets, on confirme l'acceptation et le tarif.",
          },
          {
            n: "3",
            icon: <Recycle className="w-7 h-7" strokeWidth={2.5} />,
            t: "Déchargement & tri",
            d: "Vous déchargez dans la zone dédiée à votre matière. Notre équipe est là pour vous guider. Re-pesée à vide.",
          },
          {
            n: "4",
            icon: <FileCheck className="w-7 h-7" strokeWidth={2.5} />,
            t: "Bon de pesée & paiement",
            d: "On vous remet un bon de pesée officiel (poids, matière, date, prix). Paiement à la tonne ou à la benne selon votre choix. Facture mensuelle possible pour les comptes pros.",
          },
        ].map((s) => (
          <div
            key={s.n}
            className="bg-white border border-stone-100 rounded-3xl p-6 flex items-start gap-5 hover:-translate-y-0.5 hover:shadow-lg transition-all"
          >
            <div className="shrink-0 w-16 h-16 rounded-2xl bg-[#1F6B2E] text-white grid place-items-center font-heading font-black text-2xl relative">
              {s.icon}
              <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#9DCB2E] text-[#0f3a18] grid place-items-center text-sm font-black shadow">
                {s.n}
              </span>
            </div>
            <div>
              <h3 className="font-heading font-black text-xl text-stone-900">{s.t}</h3>
              <p className="text-stone-600 mt-1 leading-relaxed">{s.d}</p>
            </div>
          </div>
        ))}

        <div className="bg-[#f6faf0] rounded-3xl p-6 sm:p-8 mt-8 text-center border border-[#9DCB2E]/30">
          <h3 className="font-heading font-black text-2xl text-[#1F6B2E]">
            Volume important ou question particulière ?
          </h3>
          <p className="text-stone-600 mt-2 max-w-xl mx-auto">
            Pour plus d&apos;informations, contactez-nous — on s&apos;adapte à votre situation.
          </p>
          <div className="mt-5 flex flex-wrap gap-3 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#1F6B2E] hover:bg-[#175522] text-white font-bold px-5 py-3 rounded-full"
            >
              Nous contacter <ArrowRight className="w-4 h-4" strokeWidth={3} />
            </Link>
            <span className="inline-flex items-center gap-1.5 text-stone-600 text-sm font-bold">
              <MapPin className="w-4 h-4" strokeWidth={2.5} /> {SITE.address.full}
            </span>
          </div>
        </div>
      </section>
    </div>
  );
}
